"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _searchDealershipsSelectFilter = _interopRequireDefault(require("../../styles/search-dealerships-select-filter.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var _types = _interopRequireDefault(require("../types"));
var SelectFilter = function SelectFilter(_ref) {
  var filterOptions = _ref.filterOptions,
    name = _ref.name,
    selectedType = _ref.selectedType,
    handleUpdateDealerShipType = _ref.handleUpdateDealerShipType,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(selectedType) || !(0, _checkProps["default"])(name)) {
    var filterOptionsFilter = filterOptions.filter(function (filterOption) {
      if (filterOption.label.length > 2) {
        return true;
      }
      return false;
    });
    return /*#__PURE__*/_react["default"].createElement("select", {
      onChange: function onChange(e) {
        return handleUpdateDealerShipType(e.currentTarget.value);
      },
      value: selectedType,
      name: name,
      id: name,
      className: theme.customSelect + " " + _searchDealershipsSelectFilter["default"].filterSelect
    }, filterOptionsFilter.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option.value,
        value: option.value
      }, option.label);
    }));
  }
  return null;
};
var _default = SelectFilter;
exports["default"] = _default;